import { IDailyOptions } from './DaysOfWeek';

export function isValidZipCode(zipCode: string): boolean {
  return /^\d{5}$/.test(zipCode);
}

export const isTrialShefRegion = (region: { trialShefsEnabledAt: Date | null }): boolean => {
  if (!region.trialShefsEnabledAt) return false;
  return region.trialShefsEnabledAt.getTime() < Date.now();
};

export const isSubscriptionRegion = (region: { subscriptionsEnabledAt: Date | null }): boolean => {
  if (!region.subscriptionsEnabledAt) return false;
  return region.subscriptionsEnabledAt.getTime() < Date.now();
};

export function regionToDailyOptions(region: {
  sundayDelivery: boolean;
  mondayDelivery: boolean;
  tuesdayDelivery: boolean;
  wednesdayDelivery: boolean;
  thursdayDelivery: boolean;
  fridayDelivery: boolean;
  saturdayDelivery: boolean;
}): IDailyOptions {
  return {
    sunday: region.sundayDelivery,
    monday: region.mondayDelivery,
    tuesday: region.tuesdayDelivery,
    wednesday: region.wednesdayDelivery,
    thursday: region.thursdayDelivery,
    friday: region.fridayDelivery,
    saturday: region.saturdayDelivery,
  };
}

export enum Region {
  BayArea = 'BAY_AREA',
  NewYork = 'NEW_YORK',
  Houston = 'HOUSTON',
  Nassau = 'NASSAU',
  Chicago = 'CHICAGO',
  Seattle = 'SEATTLE',
  Boston = 'BOSTON',
  LosAngeles = 'LOS_ANGELES',
  WashingtonDC = 'DC_AREA',
  Austin = 'AUSTIN',
  Dallas = 'DALLAS',
  Atlanta = 'ATLANTA',
  NewJersey = 'NEW_JERSEY',
}

export enum RegionId {
  BayArea = 1,
  NewYork = 2,
  Houston = 3,
  Nassau = 4,
  Chicago = 5,
  Seattle = 6,
  Boston = 7,
  LosAngeles = 8,
  WashingtonDC = 9,
  Austin = 10,
  Dallas = 11,
  Atlanta = 12,
  NewJersey = 13,
}
